import { useEffect, useState } from "react";
import { api } from "../lib/api";

const COLS = [
    { key: "minutes", label: "MIN" },
    { key: "points", label: "PTS" },
    { key: "rebounds", label: "REB" },
    { key: "assists", label: "AST" },
    { key: "steals", label: "STL" },
    { key: "blocks", label: "BLK" },
    { key: "fg_made", label: "FG", combo: "fg_attempts" },
    { key: "three_made", label: "3PT", combo: "three_attempts" },
    { key: "ft_made", label: "FT", combo: "ft_attempts" },
];

export default function BoxScore({ gameId }) {
    const [lines, setLines] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        api.get(`/games/${gameId}/box-score`).then((r) => {
            if (!cancelled) { setLines(r.data); setLoading(false); }
        }).catch(() => setLoading(false));
        return () => { cancelled = true; };
    }, [gameId]);

    if (loading) return <div className="text-ink text-sm p-4">Loading box score…</div>;
    if (lines.length === 0) return <div className="text-ink text-sm p-4">Box score not posted yet.</div>;

    return (
        <div className="overflow-x-auto" data-testid={`boxscore-${gameId}`}>
            <table className="w-full text-sm">
                <thead className="bg-bg-soft border-b border-line">
                    <tr>
                        <th className="text-left p-2 text-[10px] uppercase tracking-widest text-ink">Player</th>
                        {COLS.map((c) => (
                            <th key={c.key} className="text-right p-2 text-[10px] uppercase tracking-widest text-ink">{c.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {lines.map((l) => (
                        <tr key={l.id} className="border-t border-line">
                            <td className="p-2">
                                <div className="text-white text-sm">{l.player_name}</div>
                                {l.jersey_number && <div className="text-ink text-[10px]">#{l.jersey_number}</div>}
                            </td>
                            {COLS.map((c) => (
                                <td key={c.key} className="p-2 text-right h-display">
                                    {c.combo ? `${l[c.key] || 0}-${l[c.combo] || 0}` : (l[c.key] || 0)}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
